<template>
    <div id="labels">
        <div id="forest_label">
            <p id="forest_text">Forest</p>
        </div>
        <div id="traditional_label">
            <p id="traditional_text">Traditional</p>
        </div>
    </div>
    <div id="graphs">
        <div id="forest_graph">
            <svg id="forest_sp">
                <rect v-for="(i,index) in curr_forest"
                :key="i"
                class="curr_rect"
                :height="height_f"
                :y="y_f(i,index)"
                x="10%">{{index}}
                </rect>
                <text v-for="(i,index) in curr_forest"
                :key="i"
                class="curr_text"
                :y="y_ftext(i,index)"
                x="50%">
                    {{text_split(i)[0]}}
                    <tspan>{{text_split(i)[1]}}</tspan>
                    {{text_split(i)[2]}}
                </text>
            </svg>
        </div>
        <div id="traditional_graph">
            <svg id="traditional_sp">
                <rect v-for="(i,index) in curr_trad"
                :key="i"
                class="curr_rect"
                :height="height_t"
                :y="y_t(i,index)"
                x="10%">{{index}}</rect>
                <text v-for="(i,index) in curr_trad"
                :key="i"
                class="curr_text"
                :y="y_ttext(i,index)"
                x="50%">
                    {{text_split(i)[0]}}
                    <tspan>{{text_split(i)[1]}}</tspan>
                    {{text_split(i)[2]}}
                </text>
            </svg>
        </div>
    </div>
    <div>
        <p id="context">The key difference in the learning objectives is the intentionally unstructured nature of the Forest Kindergarten curriculum, where
            educators choose not to include so many rigorous math, reading, and writing lessons.</p>
    </div>
</template>

<script>
import programs from '../assets/programs.json'

export default {
  name: 'programs',
  data() {
    return {
      curr_forest: programs[0].Curriculum,
      curr_trad: programs[1].Curriculum,
      height: 700
    }
  },
  computed: {
    height_f: function() {
        return (this.height-(10*this.curr_forest.length))/this.curr_forest.length
    },
    height_t: function() {
        return (this.height-(10*this.curr_trad.length))/this.curr_trad.length
    }
  },
  methods: { 
      y_f: function(value, index) {
        return this.height/this.curr_forest.length*index+20
      },
      y_ftext: function(value, index) {
        return this.height/this.curr_forest.length*index+20 + ((this.height-(10*this.curr_forest.length))/this.curr_forest.length)/2
      },
      y_t: function(value, index) {
        return this.height/this.curr_trad.length*index+20
      },
      y_ttext: function(value, index) {
        return this.height/this.curr_trad.length*index+20 + ((this.height-(10*this.curr_trad.length))/this.curr_trad.length)/2 + 5
      },
      text_split: function(value) {
        return value.split("-")
      }
  },
  components: {
  },
  setup() {
  }
}
</script>

<style>
.curr_rect {
    fill: #467552;
    fill-opacity: .5;
    width: 80%;
    margin-right: 10%;
    margin-left: 10%;
    rx: 5px;
    stroke-width: 1;
    stroke: white;
}

.curr_text {
    fill: lightgrey;
    font-family: Josefin;
    text-anchor:middle;
    font-size: 1.3vw;
}

.curr_text>tspan {
    font-family: JosefinB;
    fill: white;
    font-size: 1.5vw;
}
</style>
